import React from 'react';
import { AspectRatio } from '@/components/ui/aspect-ratio';
import { Play } from 'lucide-react';

interface ShortsCardProps {
  id: string;
  title: string;
  thumbnailUrl: string;
  onClick?: () => void;
}

const ShortsCard: React.FC<ShortsCardProps> = ({ id, title, thumbnailUrl, onClick }) => {
  const handleClick = (e: React.MouseEvent) => {
    if (onClick) {
      e.preventDefault();
      onClick();
    }
  };

  return (
    <a
      href={`https://www.youtube.com/shorts/${id}`}
      target="_blank"
      rel="noopener noreferrer"
      className="group block overflow-hidden rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-primary"
      aria-label={`Watch YouTube Short: ${title}`}
      onClick={handleClick}
    >
      <AspectRatio ratio={9/16}>
        <img
          src={thumbnailUrl}
          alt={`${title} - YouTube Short from Everhouse`}
          loading="lazy"
          className="h-full w-full object-cover"
        />
        <div className="pointer-events-none absolute inset-0 bg-gradient-to-b from-black/0 via-black/20 to-black/50 opacity-0 group-hover:opacity-100 transition-opacity" />
        <div className="pointer-events-none absolute bottom-2 left-2 right-2 flex items-center gap-2 text-white">
          <span className="inline-flex h-7 w-7 items-center justify-center rounded-full bg-black/60">
            <Play size={16} className="ml-0.5" />
          </span>
          <p className="line-clamp-1 text-sm">{title}</p>
        </div>
      </AspectRatio>
    </a>
  );
};

export default ShortsCard;
